<template>
  <div>
    <div class="wrapper">
      <div class="form-signin" id="usuario">
        <img 
          id="logo" 
          v-if="certificandoLogin == 'N'"
          src="static/imagens/logos/logo_santri.svg" 
          class="w3-margin-bottom">
        
        <h2 
          id="tituloTerceiros" 
          v-if="certificandoLogin == 'N'">
          Acesso de terceiros
        </h2>

        <input
          required
          autofocus
          type="number"
          id="usuario_id"
          class="w3-input"
          v-model="usuario_id"
          style="margin-bottom:5px;"
          placeholder="Código do usuário"
          :readonly="certificandoLogin == 'S'">
        
        <input
          required
          id="senha"
          type="password"
          v-model="senha"
          placeholder="Senha"
          class="w3-input w3-border-bottom"
          @keydown.enter="realizarLogin()">
        <br>

        <div 
          class="w3-container w3-center" 
          v-if="(
            dados_sessao && 
            dados_sessao.tentativas_fracassadas_login && 
            (dados_sessao.tentativas_fracassadas_login > 2)
          )">
          <vue-recaptcha sitekey="6LdDNCQUAAAAAD1-FugFYspeKCsbOAaAwRDvhGTg"/>
        </div>
        <br>

        <button
          id="btLogin"
          :disabled="logando"
          v-on:click="realizarLogin()"
          class="w3-btn w3-theme w3-block">
          <i class="fa fa-unlock-alt"/>
          <b>Login</b>
        </button>

        <router-link
          v-cloak
          to="/login"
          id="btTerceiros"
          v-if="certificandoLogin == 'N'"
          class="w3-btn w3-white w3-block w3-border w3-margin-top">
          <i class="fa fa-user w3-text-theme"/>
          <b class="texto-vermelho">Sou usuário ADM</b>
        </router-link>

        <div 
          style="margin-bottom: 20px;"
          v-if="certificandoLogin == 'S'" 
        />

      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import RSessao from '@/components/Rest/RSessao'
import RParametro from '@/components/Rest/RParametro.js'
import Biblioteca from '@/components/Repositorio/Biblioteca'

export default {
  name: "LoginTerceiros",
  components: {
    VueRecaptcha
  },
  props:{
    certificandoLogin: {
      required: false,
      type: String,
      default: "N"
    },

    dadosUsuarioLogado: {
      required: false,
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      api: process.env.API,
      usuario_id: '',
      senha: '',
      logando: false,
      dados_sessao: undefined
    };
  },
  
  methods: {
    async realizarLogin(){
      await this.atualizarParametrosLogin();

      if (this.usuario_id == ""){
        Biblioteca.exclamar('Código do usuário não informado!');
        $('#usuario_id').focus();
        return;
      }

      if (this.senha == ""){
        Biblioteca.exclamar('Senha não informada!');
        $('#senha').focus();
        return;
      }

      this.logando = true;
      let recaptcha_response = '';
      if (this.dados_sessao.tentativas_fracassadas_login > 2) {
        recaptcha_response = grecaptcha.getResponse();
      }

      let compilacao_dist = await buscarCompilacaoDist();

      let parametros = {
        usuario_id: this.usuario_id,
        senha: this.senha,
        nome_usuario_santri: this.nome_usuario_santri,
        senha_usuario_santri: this.senha_usuario_santri,
        'g-recaptcha-response': recaptcha_response,
        compilacao_dist: compilacao_dist,
        sistema_operacional: Biblioteca.buscarSistemaOperacionalDispositivo(),
        navegador: Biblioteca.buscarNomeNavegador(),
        modo_lite_ativo: Biblioteca.buscarModoEconomiaDadosDispositivo() ? 'S' : 'N',
        velocidade: Biblioteca.buscarVelocidadeDownloadDispositivo(true),
        descricao_dispositivo: (
          'Memória ram: ' + Biblioteca.buscarMemoriaRamDispositivo() + ' | ' +
          'Latência: ' + Biblioteca.buscarDadosLatenciaDispositivo() + ' | ' + 
          'Tipo de rede: ' + Biblioteca.buscarTipoRedeDispositivo()
        )
      };
      
      RSessao.criarSessaoTerceiro(this.axios, parametros).then(async (retorno_login) => {
        if (retorno_login.houve_erro != 'N'){
          swal(retorno_login.mensagem);
          this.logando = false;
          return;
        }

        await RSessao.setDadosSessaoUsuario(
          'N', 
          retorno_login.dados.tipo_autenticacao, 
          this.usuario_id
        );

        if (this.certificandoLogin == 'S'){
          this.$emit('confirmarLogin');
          return;
        }
        
        this.$router.replace('/principal-terceiros');
      })
      .catch((e) => {
        Biblioteca.exclamar(e.message);
        this.logando = false;
      })
    },

    async atualizarParametrosLogin(){
      try {
        let retorno = await RParametro.buscarParametrosLogin(this.axios);
        
        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        if ((!retorno) || (!retorno.dados)) {
          return;
        };

        if
          (
            (retorno.dados.utilizar_cotacao != 'S') &&
            (retorno.dados.utilizar_manifesto != 'S')
          ) 
        {
          document.location = '/nao-autorizado';
        }

        if (Biblioteca.em(retorno.dados.tipo_sessao_criada, ['FRN', 'MOT'])) {
          this.$router.replace('/principal-terceiros');
          return;
        };

        this.dados_sessao = await JSON.parse(JSON.stringify(retorno.dados));
      } catch (e) {
        Biblioteca.exclamar(e.message);
      }
    }
  },

  async mounted() {
    await this.atualizarParametrosLogin();

    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
    recaptchaScript.async = true;
    recaptchaScript.defer = true;
    document.head.appendChild(recaptchaScript);

    if (this.certificandoLogin == 'S'){
      this.usuario_id = this.dadosUsuarioLogado.usuario_id;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face{
  font-family: 'Yesteryear';
  src: url('/static/fonts/Yesteryear-Regular.ttf');
  font-weight: normal;
  font-style: normal;
}

body {
  background: #ffffff;
}

#logo {
  width: 15rem;
  margin-top: 20%;
}

#tituloTerceiros {
  background: #757575;
  margin-left: 0px;
  font-weight: bolder;
  font-size: 24px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (max-height: 340px) {
  #logo {
    margin-top: 0;
  }
}

.form-signin {
  width: 360px;
  padding: 8% 0 0;
  margin: auto;
  text-align: center;
  max-width: 95%;
}

.form {
  position: relative;
  z-index: 1;
  background: #8d1007;
  max-width: 360px;
  margin: 0 auto 100px;
  padding: 45px;
  text-align: center;
}

.form-control {
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginTerceiros.vue